import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from "vuex";
export default {
    data: function data() {
        return {
            dialog: false,
            reason: null,
            radios: ['Condiciones Técnicas', 'No tiene cuenta bancaria', 'No apertura local', 'RUC invalido', 'Solicitud de tercero', 'Tarifas altas']
        };
    },

    methods: _extends({}, mapMutations({
        emptyData: "affiliations/form/emptyData"
    }), {
        showModal: function showModal() {
            this.dialog = true;
        },
        returnModal: function returnModal() {
            this.$emit('return');
            this.dialog = false;
        },
        close: function close() {
            if (this.reason === null) return;
            this.$emit('saveData', Number(this.reason) + 1);
            this.dialog = false;
            this.emptyData();
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/not-affiliation-finalized.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/modals/not-affiliation-finalized.vue
// module chunks = 34